import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_79: FaireProductEntity = {
  token: "starter_collection_79",
  type: "product",
  name: "Everyday Salad Oil",
  brandName: "Brightland",
  imageUrl:
    '"https://cdn.faire.com/fastly/b7587ec3e78079a827c6f3895867c512ce029bc6667606af99dac82883d06c84.png?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1040',
  priceDollars: 32,
  msrpDollars: 64,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
